import type { IPurchaserRepository } from "@src/domain/repositories/purchaser";

export class GetPurchasersUseCase {
  private readonly purchaserRepository: IPurchaserRepository;

  constructor(purchaserRepository: IPurchaserRepository) {
    this.purchaserRepository = purchaserRepository;
  }

  execute(page: number, limit: number) {
    return this.purchaserRepository.getPurchasers(page, limit);
  }
}
